import React from "react";
import { Row, Col, Modal, Button } from "antd";
import commonStyles from "../DashBoardMobile/DashBoardMobile.module.scss";
import styles from "./Payment.module.scss";
import { useBillingHistoryFilterActions } from "../../../hooks/useBillingHistoryFilterActions";

type Props = {
  isOpenFilter: boolean;
  setIsOpenFilter: React.Dispatch<React.SetStateAction<boolean>>;
  onFilterCount: Function;
};

const BillingHistoryFilterModal: React.FC<Props> = ({
  isOpenFilter,
  setIsOpenFilter,
  onFilterCount,
}) => {
  const {
    transactionTypesOptions,
    checkedTransactionTypes,
    handleApplyFilters,
    handleReset,
    handleTransactionTypesClick,
  } = useBillingHistoryFilterActions(setIsOpenFilter, onFilterCount);

  return (
    <Modal
      visible={isOpenFilter}
      width={577}
      centered
      className={commonStyles.filterModal}
      footer={
        <Row
          justify="center"
          gutter={[10, 0]}
          className={commonStyles.modalFilterFooterMargin}
        >
          <Col>
            <Button className={commonStyles.resetFilters} onClick={handleReset}>
              Reset
            </Button>
          </Col>
          <Col>
            <Button
              className={commonStyles.applyFilterBtn}
              onClick={handleApplyFilters}
            >
              Apply Filters
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center">
        <Col className={commonStyles.modalFilterHeadings}>Filter by...</Col>
      </Row>
      <Row className={commonStyles.filterHeadingMargin}>
        <Col span={24} className={commonStyles.filterHeadings}>
          Transaction Types
        </Col>
        <Col span={24} className={styles.filterBtnsContainer}>
          {transactionTypesOptions.map((option) => (
            <Button
              key={option}
              onClick={() => handleTransactionTypesClick(option)}
              className={
                checkedTransactionTypes.has(option)
                  ? styles.filterCheckBtns
                  : styles.filterUncheckBtns
              }
            >
              {option}
            </Button>
          ))}
        </Col>
      </Row>

      {/* For Wanda Phase-2 */}

      {/* <Row className={commonStyles.filterHeadingMargin}>
        <Col span={24} className={commonStyles.filterHeadings}>
          Service Users
        </Col>
        <Col span={24} className={commonStyles.noRipple}>
          {serviceUsersOptions.map((option) => (
            <Button
              key={option}
              onClick={() => handleUsersClick(option)}
              className={
                checkedServiceUsers.has(option)
                  ? commonStyles.filterCheckBtns
                  : commonStyles.filterUncheckBtns
              }
            >
              {option}
            </Button>
          ))}
        </Col>
      </Row> */}
    </Modal>
  );
};

export default BillingHistoryFilterModal;
